export const limitPrice = 50000;
